// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmAclRoleUser {
constructor({
        id = null,
        roleId = '',
        userId = ''}
= {}) {
    this.id = id;
    this.roleId = roleId;
    this.userId = userId;
}
}

function newEntity() {
return new EmAclRoleUser();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'roleName',
        label: 'label.em.admin.emAclRoleUser.grid.roleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleStatus',
        label: 'label.em.admin.emAclRoleUser.grid.roleStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'roleType',
        label: 'label.em.admin.emAclRoleUser.grid.roleType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '管理员' },
                            { value: '2', text: '普通用户' }
            ]
        }
        },
        {
        key: 'roleAclLevel',
        label: 'label.em.admin.emAclRoleUser.grid.roleAclLevel',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '读写' },
                            { value: '2', text: '只读' }
            ]
        }
        },
        {
        key: 'roleDeptAclLevel',
        label: 'label.em.admin.emAclRoleUser.grid.roleDeptAclLevel',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '无限制' },
                            { value: '4', text: '本部门及子部门' },
                            { value: '6', text: '仅本部门' }
            ]
        }
        },
        {
        key: 'userName',
        label: 'label.em.admin.emAclRoleUser.grid.userName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'userStatus',
        label: 'label.em.admin.emAclRoleUser.grid.userStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '在职' },
                            { value: '2', text: '离职' },
                            { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'userEmployeeId',
        label: 'label.em.admin.emAclRoleUser.grid.userEmployeeId',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    roleIdFilter : "",
    userIdFilter : "",
    roleNameFilter : "",
    roleTypeFilter : "",
    roleStatusFilter : "",
    roleAclLevelFilter : "",
    roleDeptAclLevelFilter : "",
    userNameFilter : "",
    userEmployeeIdFilter : "",
    userStatusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'roleIdFilter',
        label: 'label.em.admin.emAclRoleUser.filter.roleId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'userIdFilter',
        label: 'label.em.admin.emAclRoleUser.filter.userId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'roleNameFilter',
        label: 'label.em.admin.emAclRoleUser.filter.roleName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'roleTypeFilter',
        label: 'label.em.admin.emAclRoleUser.filter.roleType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '管理员' },
                { value: '2', text: '普通用户' }
            ]
        }
        },
        {
        key: 'roleStatusFilter',
        label: 'label.em.admin.emAclRoleUser.filter.roleStatus',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'roleAclLevelFilter',
        label: 'label.em.admin.emAclRoleUser.filter.roleAclLevel',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '读写' },
                { value: '2', text: '只读' }
            ]
        }
        },
        {
        key: 'roleDeptAclLevelFilter',
        label: 'label.em.admin.emAclRoleUser.filter.roleDeptAclLevel',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '无限制' },
                { value: '4', text: '本部门及子部门' },
                { value: '6', text: '仅本部门' }
            ]
        }
        },
        {
        key: 'userNameFilter',
        label: 'label.em.admin.emAclRoleUser.filter.userName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'userEmployeeIdFilter',
        label: 'label.em.admin.emAclRoleUser.filter.userEmployeeId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'userStatusFilter',
        label: 'label.em.admin.emAclRoleUser.filter.userStatus',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '在职' },
                { value: '2', text: '离职' },
                { value: '3', text: '删除' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'roleId',
        label: 'label.em.admin.emAclRoleUser.entity.roleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'userId',
        label: 'label.em.admin.emAclRoleUser.entity.userId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        }
]

export {EmAclRoleUser, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
